import { Instagram, Twitter, Youtube, Mail } from "lucide-react";
import ZokuMark from "@/components/ZokuMark";

export default function Footer() {
  return (
    <footer className="bg-zoku-ink text-stone-400 pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center leading-none">
              <img
                src="https://customer-assets.emergentagent.com/job_zoku-wellness-hub/artifacts/d6p51lbc__Logo%20%28500%20x%20200%20px%29%20%281%29.png"
                alt="Zoku"
                className="h-12 w-auto object-contain select-none"
                draggable={false}
                style={{ mixBlendMode: "screen" }}
              />
            </div>
            <p className="mt-5 max-w-sm text-stone-400 leading-relaxed">
              The complete Health OS. Calories, sleep, recovery, water, activity — honest
              tracking, no hidden nasties, priced for real people.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Instagram, Twitter, Youtube, Mail].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 rounded-full border border-stone-700 flex items-center justify-center hover:border-zoku-orange hover:text-zoku-orange transition"
                  aria-label="social"
                  data-testid={`footer-social-${i}`}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-10">
            {[
              {
                h: "Product",
                l: [
                  { label: "Features", href: "/#features" },
                  { label: "Intelligence", href: "/#intelligence" },
                  { label: "Download", href: "/#download" },
                  { label: "Changelog", href: "#" },
                ],
              },
              {
                h: "Company",
                l: [
                  { label: "About", href: "#" },
                  { label: "Careers", href: "#" },
                  { label: "Press", href: "#" },
                  { label: "Support", href: "/support" },
                ],
              },
              {
                h: "Legal",
                l: [
                  { label: "Privacy", href: "/privacy" },
                  { label: "Terms", href: "/terms" },
                  { label: "Cookie Policy", href: "/privacy#cookies" },
                  { label: "Security", href: "#" },
                ],
              },
            ].map((c, i) => (
              <div key={i}>
                <div className="text-white font-semibold text-sm mb-4">{c.h}</div>
                <ul className="space-y-2.5 text-sm">
                  {c.l.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        className="hover:text-white transition-colors"
                        data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-stone-500">
          <p>© {new Date().getFullYear()} Thriveage Wellness Pvt Ltd.</p>
          <p>Made with warmth in Bengaluru & London.</p>
        </div>
      </div>
    </footer>
  );
}
